import React from 'react'

// icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'

// services
import { recoverCompraDeleted } from '../../Services/compraService'

// Sweet alert
import Swal from 'sweetalert2'

// utils
import {
    formatFechaArgentina,
    formatFechaNegocio,
} from '../../utils/fechaArgentina'

// router
import { withRouter } from 'react-router-dom'

const ItemCompraEliminado = ({ compra, setIsLoad }) => {
    const estado = (estado) => {
        if (estado === 'ADEUDADA')
            return <p className="text-primary">ADEUDADA</p>
        if (estado === 'PAGADA_PARCIALMENTE')
            return <p className="text-warning">PAGADA PARCIALMENTE</p>
        if (estado === 'PAGADA') return <p className="text-success">PAGADA</p>
    }

    const recoverCompraSubmit = (compra) => {
        let text =
            'Se volverá a agregar el stock de los artículos de esta compra.'
        if (compra.estado === 'ADEUDADA') {
            text +=
                ' También se sumará $' +
                compra.total.toFixed(2) +
                ' a la deuda (debo) del proveedor.'
        }
        text +=
            ' Si se eliminó antes de que el sistema descontara stock al borrar, recuperar igual aumentará el stock.'
        Swal.fire({
            title: 'Estas seguro de recuperarla?',
            text,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, Recuperar!',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.value) {
                recoverCompraDeleted(compra.id)
                    .then((res) => {
                        Swal.fire(
                            'Recuperado!',
                            'La compra fue recuperada.',
                            'success'
                        )
                        setIsLoad(true)
                    })
                    .catch((error) => {
                        Swal.fire({
                            type: 'error',
                            title: 'Error',
                            text:
                                (error.response &&
                                    error.response.data &&
                                    error.response.data.message) ||
                                'Hubo un error vuelve a intentar!',
                        })
                        console.log(error.response)
                    })
            }
        })
    }

    return (
        <tr>
            <th scope="row">{compra.id}</th>
            <td>{compra.proveedor.nombre}</td>
            <td>${compra.total.toFixed(2)}</td>
            <td>{estado(compra.estado)}</td>
            <td>{formatFechaNegocio(compra.fecha)}</td>
            <td>{formatFechaArgentina(compra.createdAt)}</td>
            <td>{compra.sucursal.nombre}</td>
            <td>{compra.tipoComprobante.nombre}</td>
            <td>{compra.numeroComprobante}</td>
            <td>
                <button
                    className="btn text-warning"
                    onClick={() => {
                        recoverCompraSubmit(compra)
                    }}
                >
                    <FontAwesomeIcon icon={faTrash} /> Recuperar
                </button>
            </td>
        </tr>
    )
}

export default withRouter(ItemCompraEliminado)
